import { createFileRoute } from "@tanstack/react-router";
import { EquipmentSettingsPage } from "../../../../../pages/organisation-page/organisation-settings-pages";

export const Route = createFileRoute("/_auth/_organisation/organisation/resources/equipment")({
  component: EquipmentSettingsPage,
});
